import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { IModalWrapper } from "./Interfaces";
import "./ModalWrapper.scss";
import classNames from "classnames";

export function ModalWrapper(props: IModalWrapper) {
    const { children, title, onClose, submitButton, onSubmit, data } = props;
    return (
        <>
            <div className=" modal-wrapper modal fade show d-block" tabIndex={1} id="modalWrapper" role="dialog" aria-hidden="true" >
                <div className={classNames(
                    {
                        "modal-dialog-device": title === "Device Information" ? true : false,
                        "modal-dialog" : title !=="Device Information"? true : false,
                    }
                )} role="document">
                    <div className="modal-content">
                        {title !== "Device Log" &&
                            <div className="modal-header modal-header-wrapper">
                                <div>
                                    <span id="header" className="modal-title w-100"> {title} </span>
                                    {data &&
                                        <p className="mt-2 mb-0">
                                            <b>{data?.message}  </b> Expiry Date :  &nbsp;
                                            {data?.data?.expiry_date}
                                        </p>
                                    }
                                </div>
                                <div className="font-icon" onClick={() => onClose && onClose(false)}>
                                    <FontAwesomeIcon icon={faTimes} className="mx-1 menu-link-hoverable pointer" data-dismiss="modal" />
                                </div>
                            </div>
                        }
                        {children}
                        {submitButton &&
                            <div className="no-border-footer modal-footer justify-content-center" >
                                <div className="dis">
                                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mx-4 set-qc-button" onClick={() => onClose && onClose(false)} >{submitButton}</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    )
}

export default ModalWrapper;